import { render, staticRenderFns } from "./out_sourcing_order_detail.vue?vue&type=template&id=2ea401ab&scoped=true"
import script from "./out_sourcing_order_detail.vue?vue&type=script&lang=js"
export * from "./out_sourcing_order_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea401ab",
  null
  
)

export default component.exports